<template>
    <Collapse v-if="list.length">
        <template slot="title">
            {{tab == SectionTabs.TEAM ? t('selectMember.team') : t('selectMember.teamMember')}}
        </template>
        <template slot="content">
            <TeamNode 
                v-for="(item, index) in list"
                :data="item"
                :key="index"
                :withMembers="tab == SectionTabs.TEAM_MEMBER"
                @handleExpand="handleExpand"
                @handleChecked="handleChecked"/>
            <Load v-if="hasMore" 
                :hasData="!!list.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="handleSearch"/>
        </template>
    </Collapse>
</template>
<script>
import Mixin from './mixin';
import { getTeamList, getTeamMemberList } from '../utils';
import TeamNode from '../section/section-team-node';
import { SectionTabs } from '../val';


export default {
    name: 'SearchTeamResult',
    mixins: [ Mixin ],
    components: {
        TeamNode
    },
    data() {
        return {
            withMembers: this.tab == SectionTabs.TEAM_MEMBER
        }
    },
    methods: {
        handleSearch() {
            this.loading = true;
            const { host, qzId, keyword, language, token } = this.root;
            return getTeamList(host, qzId, {
                keyword: keyword,
                page: this.page,
                size: this.size,
                language: language,
                token: token
            }).then(res => {
                let data = res.data
                if(!Array.isArray(data)) throw new Error();
                data.forEach(item => {
                    item.type = 4;
                    item.expand = false;
                    item.checked = false;
                    item.loading = false;
                    item.children = []
                })
                this.list = this.list.concat(data);
                this.page ++;
                this.hasMore = data.length >= this.size;
            }).catch(err => {
                this.list = [];
                this.hasMore = true;
            }).finally(() => {
                this.loading = false;
            })
        },
        getMemberList(teamId, params, isSelect) {
            const { host, qzId, language, security, token } = this.root
            params && (params.loading = true)
            getTeamMemberList(host, qzId, teamId, {
                keyword: '',
                    page: 1,
                    size: 300,
                    language: language,
                    withSecurity: security,
                    tmp: new Date().valueOf(),
                    token: token,
                    includeDuty: true
            }).then(res => {
                let data = res && res.data || []
                data.forEach(item => {
                    item.checked = !!isSelect || false
                    item.type = 0
                    item.isIssueGroup = true
                    if (isSelect) {
                        this.root.handleSelected(item)
                    }
                })
                params && (params.loading = false)
                params && (params.children = data)
            }).catch(res => {
                params.loading = false
            })
        },
        handleChecked(checked, data) {
            if(data.loading) return false
            if(!this.withMembers || data.type === 0) {
                if(checked && 1 + this.root.selectedCount > this.root.limit && this.root.limit != 1) {
                    Message.warning(this.t('selectMember.maximum'))
                    return false
                }
                data.checked = checked
                this.root.handleSelected(data)
                return true
            } 
            if(checked && data.count + this.root.selectedCount > this.root.limit) {
                Message.warning(this.t('selectMember.maximum'))
                return false
            }
            if(data.children && data.children.length) {
                data.checked = checked
                data.children.forEach((item)=>{
                    item.checked = checked
                    this.root.handleSelected(item)
                })
                return true
            } 
            data.expand = true
            this.getMemberList(data.id, data, true)
            return true
        },
        handleExpand(expand, data) {
            data.expand = expand
            if(data.children && data.children.length) return
            this.getMemberList(data.id, data)
        },
    }
}
</script>
